import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ driver, onClose, onConfirm }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    setTimeout(() => {
      onConfirm(driver?.id);
      setIsDeleting(false);
    }, 1000);
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[200] flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-elevation-3 w-full max-w-md">
        <div className="px-6 py-4 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-destructive/10 rounded-lg">
              <Icon name="AlertTriangle" size={20} color="var(--color-destructive)" strokeWidth={2} />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Delete Driver</h2>
              <p className="text-xs text-muted-foreground">This action cannot be undone</p>
            </div>
          </div>
        </div>

        <div className="px-6 py-4">
          <p className="text-sm text-foreground mb-4">
            Are you sure you want to delete <span className="font-semibold">{driver?.name}</span> ({driver?.driverId})?
          </p>
          <div className="bg-destructive/5 border border-destructive/20 rounded-lg p-3">
            <div className="flex items-start space-x-2">
              <Icon name="Info" size={16} color="var(--color-destructive)" strokeWidth={2} className="mt-0.5 flex-shrink-0" />
              <div className="text-xs text-muted-foreground">
                <p className="font-medium text-destructive mb-1">Warning:</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>All driver information will be permanently deleted</li>
                  <li>Assignment history will be archived but not accessible</li>
                  <li>This action cannot be reversed</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end space-x-3 px-6 py-4 border-t border-border bg-muted/30">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            loading={isDeleting}
            iconName="Trash2"
          >
            Delete Driver
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;